import { render, staticRenderFns } from "./ListDesa.vue?vue&type=template&id=4fdfcc8e&scoped=true"
import script from "./ListDesa.vue?vue&type=script&lang=js"
export * from "./ListDesa.vue?vue&type=script&lang=js"
import style0 from "./ListDesa.vue?vue&type=style&index=0&id=4fdfcc8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdfcc8e",
  null
  
)

export default component.exports